import type { Permission } from '@teachino/shared-util';
import { useGlobalDependencyProvider } from '@teachino/shared-util';
import type { Ref } from 'vue';

const MANAGE_STUDENTS: Permission = 'manage_students';

/**
 * Whether the licence lets the teacher create, rename and merge students
 * (`manage_students`, TE-3552). Distinct from a course store's
 * `canManageStudents`, which is course edit access.
 *
 * Reads the raw licence flag instead of going through `useCanUseProFeature`:
 * the key is neither paywall- nor trial-expiry-gated and the legacy grace
 * window has closed, so the flag is the whole rule. That also keeps it usable
 * in the course store, which can be created outside component setup where
 * `useLicense()`'s urql queries are unavailable.
 */
export function useHasManageStudentsFeature(): Ref<boolean> {
  return useGlobalDependencyProvider()
    .inject('user')
    .hasPermission(MANAGE_STUDENTS);
}
